import { default as createRouter } from './router';
import { default as createStore } from './store';
import { createVueApollo } from './apollo';

export { createRouter, createStore, createVueApollo };
